import React from 'react';
import Modal from 'react-bootstrap/Modal';

const ModalContainer = ({
	onCloseModal = () => {},
	children,
	defaultProps = {},
	className = 'gallery-modal-main',
	centered = true,
	dialogClassName = '',
	isSaticBackdrop = false
}) => {
	return (
		<div>
			<Modal
				{...defaultProps}
				show={true}
				onHide={onCloseModal}
				backdrop={isSaticBackdrop ? 'static' : true}
				className={className}
				dialogClassName={dialogClassName}
				centered={centered}
			>
				{children}
			</Modal>
		</div>
	);
};

export default ModalContainer;
